import React from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#05339c]">
      <PublicNav />
      <div className="flex justify-center items-center min-h-screen p-6">
        <div className="p-12 w-full text-center">
          <div className="mb-6">
            <h1 className="text-9xl font-bold text-yellow mb-4">404</h1>
            <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
          </div>
          
          <h2 className="text-3xl font-bold text-white mb-4">الصفحة غير موجودة</h2>
          <p className="text-gray-300 text-lg mb-8">
            عذراً، الصفحة التي تبحث عنها غير موجودة.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
            <Link
              to="/"
              className="bg-yellow text-dark-blue py-3 px-8 rounded-md hover:bg-yellow/80 transition-all duration-300 font-bold shadow-lg"
            >
              العودة للرئيسية
            </Link>
            <Link
              to="/apply"
              className="bg-transparent border-2 border-yellow text-yellow py-3 px-8 rounded-md hover:bg-yellow/10 transition-all duration-300 font-bold"
            >
              التسجيل في الهاكاثون
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;

